import { render, staticRenderFns } from "./FieldSetup.vue?vue&type=template&id=ba58746e&scoped=true&"
import script from "./FieldSetup.vue?vue&type=script&lang=ts&"
export * from "./FieldSetup.vue?vue&type=script&lang=ts&"
import style0 from "./FieldSetup.vue?vue&type=style&index=0&id=ba58746e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba58746e",
  null
  
)

export default component.exports